import React from "react";

const Cancelled = () => {
  return (
    <svg
      aria-hidden="true"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="8" r="4.45" stroke="#C24E00" strokeWidth="1.1" />
      <path
        d="M4.875 5.50195L11.125 10.502"
        stroke="#C24E00"
        strokeWidth="1.1"
      />
    </svg>
  );
};

export default Cancelled;
